const ClientDashboardReducer = (state = {}, action) => {
    switch (action.type) {
        case "getClientShipCountSuccess": {
            return Object.assign({}, state, {
                ClientShipCount: action.data,
            });
            break;
        }
        case "getClientShipCountFailure":
            return Object.assign({}, state, {
                ClientShipCount: action.data,
            });
            break;
        case "getClientShipSearchSuccess": {
            return Object.assign({}, state, {
                ClientShipSearch: action.data,
            });
            break;
        }
        case "getClientShipSearchFailure":
            return Object.assign({}, state, {
                ClientShipSearch: action.data,
            });
            break;
        case "shipClientSuccess": {
            return Object.assign({}, state, {
                ShipClientSuccess: action.data,
            });
            break;
        }
        default: {
            return state;
        }
    }
};
export default ClientDashboardReducer;
